import {
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    Chip,
    IconButton,
    Paper,
    MenuList,
    MenuItem,
    Popper,
    ClickAwayListener,
    Avatar,
  } from "@mui/material";
  import { Masonry } from "@mui/lab";
  import { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import moment from "moment";
  import MoreVertIcon from "@mui/icons-material/MoreVert";
  
  import { useUser } from "../../UserPlugin/hooks/useUser";
  import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";
  import CustomButton from "../../../core/components/ui/CustomButton";
  import AddIcon from "@mui/icons-material/Add";
  import EmailIcon from '@mui/icons-material/Email';
  import CallIcon from '@mui/icons-material/Call';
import { RBACUIGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";
  
  export default function OrganizationListComponent(props) {
    const { orgList, loading } = props;
    const { listUser } = useUser();
    const navigate = useNavigate();
  
    const [popperState, setPopperState] = useState({
      anchorEl: null,
      orgUid: null,
    });
  
    useEffect(() => {
      listUser();
    }, []);
  
    const handleEllipsisClick = (event, orgUid) => {
      setPopperState((prev) => ({
        anchorEl: event.currentTarget,
        orgUid: prev.orgUid === orgUid ? null : orgUid,
      }));
    };
  
    const handleClose = () => {
      setPopperState({ anchorEl: null, orgUid: null });
    };
  
    const handleNavigate = (org_uid) => {
      navigate(`/organization/view?org_uid=${org_uid}`);
    };
  
    if (loading) return <CustomListviewLoader />;
  
    const organizationStatusStyles = {
      Approved: { backgroundColor: "#e8f5e9", color: "#4caf50" },
      Disapproved: { backgroundColor: "#F3F4F6", color: "#6B7280" },
      Pending: { backgroundColor: "#FEF9C3", color: "#854D0E" },
    };
  
    return (
      <Box sx={{width: "100%"}}>
        {/* <Box sx={{textAlign: "end"}}>
            <CustomButton
                variant="contained" 
                startIcon={<AddIcon fontSize="small" />}
                label="Create Organization"
                customStyles={{fontSize: 14, mb: 2, mr: 2}}
                onClick={() => navigate("/organization/create")}
            />
        </Box> */}
        {orgList?.content?.length > 0 ? (
          <Masonry columns={{ xs: 1, sm: 3 }} defaultColumns={3} spacing={2}>
            {orgList.content.map((org) => {
              const formattedDate = moment(org.created_at).format("MMMM DD, YYYY");
  
              return (
                <Card
                  key={org.id}
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: 6,
                      transform: "translateY(-4px)",
                    },
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  onMouseLeave={handleClose}
                >
                    <Box
                      sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          backgroundColor: "#0b99da",
                          color: "#fff",
                          padding: 1.5,
                          mb: 1.5,
                      }}
                    >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Avatar sx={{ bgcolor: "#fff", color: "#0178f2", fontSize: 14 }}>
                        {org.org_name?.[0]?.toUpperCase() || "O"}
                        </Avatar>
                        <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 600, cursor: "pointer", color:'#fff' }}
                        onClick={() => handleNavigate(org.org_uid)}
                        >
                        {org.org_name}
                        </Typography>
                    </Box>

                    <IconButton onClick={(e) => handleEllipsisClick(e, org.org_uid)} size="small" sx={{ color: "#fff" }}>
                        <MoreVertIcon />
                    </IconButton>
                    </Box>
                  <CardContent sx={{ paddingTop: 0 }}>
                    <Box onClick={() => handleNavigate(org.org_uid)}>
                      <Box sx={{ height: 40}}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          {org.description ? org.description : "No description added"}
                        </Typography>
                      </Box>
    
                        <Box sx={{display: "flex", alignItems: "center", mb: 1, mt: 2}} gap={1}>
                          <IconButton sx={{bgcolor:"#0b99da"}}>
                            <EmailIcon sx={{color:'#fff', height: 15, width: 15}}/>
                          </IconButton> 
                          <Typography>{org.contact_email}</Typography>
                        </Box>

                        <Box sx={{display: "flex", alignItems: "center" }} gap={1}>
                          <IconButton sx={{bgcolor:"#ff5353"}}>
                            <CallIcon sx={{height: 15, width: 15, color:'#fff'}}/>
                          </IconButton> 
                          
                          <Typography>{org.contact_phone}</Typography>
                        </Box>

                        <Box sx={{ mt: 1.5, display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                          >
                            Date Registered: {formattedDate}
                          </Typography>
                          <Box sx={{flexGrow: 1}} />
                          <Chip
                              label={org?.status}
                              style={organizationStatusStyles[org?.status] || {}}
                              size="small"
                          />
                        </Box>
    
                        
                    </Box>
                  </CardContent>
  
                  {/* Popper */}
                  <Popper
                    open={popperState.orgUid === org.org_uid}
                    anchorEl={popperState.anchorEl}
                    placement="bottom-end"
                    disablePortal={false}
                    
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <Paper sx={{ mt: 1, boxShadow: 3 }}>
                        <MenuList dense>
                          <RBACUIGuard requiredPermission={permissions.organizations.UPDATE_ORGANIZATION}>
                            <MenuItem onClick={() => navigate(`/organization/update?org_uid=${org.org_uid}`)}>
                              Update Organization
                            </MenuItem>
                          </RBACUIGuard>
                        </MenuList>
                      </Paper>
                    </ClickAwayListener>
                  </Popper>
                </Card>
              );
            })}
          </Masonry>
        ) : (
          <Typography textAlign="center" color="text.secondary">
            No available organization to display.
          </Typography>
        )}
      </Box>
    );
  }
  